/*
 *
 * Copyright 2019, White River Computing LLC. All rights reserved.
 * For licensing information, please contact Charlie Flock (cflock@whiterivercomputing.com or 888-802-6340)
 */

import React from "react";
import ReactDOM from "react-dom";
import PropTypes from "prop-types";
import {Button} from "@blueprintjs/core";
import {Intent} from "@blueprintjs/core/lib/esm/index";
import {WrcSpreadSheet} from "./WrcSpreadSheet.js";

export class WrcSpreadSheetOpener extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            canOutsideClickClose: false,
            is_loaded: false,
        };
    }

    showSpreadsheet() {
        ReactDOM.render(
            <WrcSpreadSheet
                form_id={this.props.form_id}
                form_tab={this.props.form_tab}
                first_col={this.props.first_col}
                filters={this.props.filters}
                title={this.props.title}
                refresh={this.props.refresh}
                component_index={this.props.component_index}
                configure_component={this.props.configure_component}
                linked_component_index={this.props.linked_component_index}
                sheet_linking_property={this.props.sheet_linking_property}
                component_linking_property={this.props.component_linking_property}/>,
            document.querySelector('#spreadsheet'));
    }

    componentDidMount() {
        this.setState({
            is_loaded: true
        });
    }

    render() {
        if (this.state.is_loaded) {
            return (
                <div className="wd-record">
                    <Button icon='th'
                            intent={Intent.PRIMARY}
                            text={this.props.button_text}
                            style={{marginTop: '1em'}}
                            fill={false}
                            onClick={() => this.showSpreadsheet()} />
                </div>
            );
        } else {
            return (<div>Loading...</div>);
        }
    }
}


WrcSpreadSheetOpener.propTypes = {
    button_text: PropTypes.string.isRequired,
    refresh: PropTypes.func,
    component_index: PropTypes.number,
    configure_component: PropTypes.func
};
